import React from 'react'
import { Form, Input } from 'antd'
import { Card, Button } from 'antd'
import LoginStyles, { Logo } from './styles'
import LOGO from '../../assets/logo/logo.png'
import { useAppDispatch, useAppSelector } from '../../hooks/useRedux'
import { login } from '../../store/user/userActions'

interface LoginValues {
  username: string
  password: string
}

const Login: React.VFC = () => {
  const dispatch = useAppDispatch()
  const isLoginLoading = useAppSelector(({ user }) => user.isLoginLoading)

  const onLogin = (userCredentials: LoginValues) => {
    dispatch(login(userCredentials))
  }

  return (
    <LoginStyles>
      <Card className='login-card' size='small' bordered>
        <Logo className='my' src={LOGO} alt='fon-radar' />

        <Form name='login' layout='vertical' requiredMark={false} onFinish={onLogin}>
          <Form.Item
            label='Username'
            name='username'
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label='Password'
            name='password'
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Button htmlType='submit' size='large' loading={isLoginLoading} block>
            Login
          </Button>
        </Form>
      </Card>
    </LoginStyles>
  )
}

export default Login
